import { ChangeEvent, useCallback, useState } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { getOrganizationList } from "src/apis/organizaApi";
import { CodeSearchModalProps } from "src/types/code-search";


import useSYS3050_R01Store, { defaultSYS3050_R01Filter } from "./Store_SYS3050_R01";
import { SYS3050_R01Dto } from "./Dto_SYS3050_R01";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";


interface Props {
  onEnterKeyDown: () => void;
}


export const SearchSection_SYS3050_R01 = (props: Props) => {
	const{ 
		onEnterKeyDown 
	} = props;

	const { compCdList, empstsCdList, orgCdList } = useCommonCodeStore();
	const { codeSearchModalVisible, setCodeSearchModalProps } = useUiuxStore();
	const { 
		SYS3050_R01Filter, setSYS3050_R01Filter,
	} = useSYS3050_R01Store();

	
    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const orgInfoHandleFoucsId = 'infoOrgInput_search';
	

    const handleOrgChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSYS3050_R01Filter({
			orgCd: e.target.value
		})
    }

	

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'orgCd',
			category: '부서',
			focusId: orgInfoHandleFoucsId,
			responseMapping: {
				orgCd: 'orgCd',
				orgNm: 'orgNm',
			},
			searchFunction: async (code: string) => {
				const orgResponse = await getOrganizationList('all');
				return orgResponse.data.data.find(value => value.orgCd === code);
			},
			extraFilter: () => ({
				orgCd: SYS3050_R01Filter.orgCd || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: SYS3050_R01Filter,
		setEditData: setSYS3050_R01Filter,
		defaultData: defaultSYS3050_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SYS3050_R01_search'
	});

	return (
		<SearchSectionForm>
				
				<SearchDropDownForm
					label="사업장"
					value={SYS3050_R01Filter.compCd}
					optionList={compCdList}
					onChangeItem={(selectedItem) => setSYS3050_R01Filter({ compCd: selectedItem?.compCd || '' })}
				/>
				<SearchCodeModalForm
					label="부서"
					value={SYS3050_R01Filter.orgCd}
					valueLabel={orgCdList.find(org => org.orgCd === SYS3050_R01Filter.orgCd)?.orgNm || ''}
					onChange={getFieldHandlers('orgCd').onChange}
					onDoubleClick={getFieldHandlers('orgCd').onDoubleClick} 
					onKeyDown={getFieldHandlers('orgCd').onEnterKeyDown}
				/>
				<SearchDropDownForm
					label="재직여부"
					value={SYS3050_R01Filter.empSts}
					optionList={empstsCdList}
					onChangeItem={(selectedItem) => setSYS3050_R01Filter({ empSts: selectedItem?.minorCd || '' })}
				/>
				<SearchDateSingleForm
					label="기준일자"
					visible={pickerVisible}		setVisible={setPickerVisible}
					value={SYS3050_R01Filter.date}
					onChange={(date) => setSYS3050_R01Filter({ date })}
					pickerPosition={pickerPosition}
					setPickerPosition={setPickerPosition}
				/>
			
		</SearchSectionForm>
	)

}